export default "/images/Exotics.svg?b010ccf762fd9dc5177ea9de137a46e5";